export default __webpack_public_path__ + "static/media/96.f3a493bd.png";